import React from "react";
import { useNavigate } from "react-router";

import { ExistingDestination } from "@prequel/react";
import { PageHeading } from "@prequel/shared-components";

interface DestinationHeaderProps {
  connection: ExistingDestination;
  customTitle?: string;
  breadcrumbs?: React.ReactNode;
  children?: React.ReactNode;
}

const DestinationHeader = ({ connection, customTitle, breadcrumbs, children }: DestinationHeaderProps) => {
  const navigate = useNavigate();

  const title = customTitle || connection.name;

  return (
    <PageHeading title={title} onGoBack={() => navigate(-1)} breadcrumbs={breadcrumbs}>
      {children}
    </PageHeading>
  );
};

export default DestinationHeader;
